import React from 'react';

import {useSelector} from 'react-redux';

import {ItemRelationsListOfGenerics} from './ItemRelationsListOfGenerics';

import type {ContentType} from 'sweet-types';

type OwnProps = {
  contentType: ContentType;
  items: Array<string>;
};
type StateProps = {
  teams: Array<{
    readonly html_url: string;
    readonly name: string;
  }>;
};
type Props = OwnProps &
  StateProps & {
    dispatch: any;
  };
export const ItemRelationsListOfTeams = ({contentType, items}: Props) => {
  const allTeams = useSelector((state) =>
    state.teamsArea
      .get('basicTeams')
      .mapKeys((id, team) => team.get('url'))
      .toJS()
  );
  const teams = items.map((url) => allTeams[url]).filter((url) => url);

  return (
    <ItemRelationsListOfGenerics contentType={contentType} items={teams} />
  );
};
